module.exports = "/images/bon-achat.svg?c521897d35daac7ad1c84b4972c8f2cc";